<template>
	<div class="financials-content-item thinner-border-bottom">
		<div class="financials-content-item-year">{{ year }}</div>
		<div class="financials-content-item-content">
			<div class="financials-content-item-content-interim" v-for="(quarterItem, index) in items" :key="index">
				<div class="quarter">
					·
					{{ $t(quarterItem.quarter === 2 ? 'pages.financials.interim' : 'pages.financials.annual') }}
				</div>
				<div class="actions-items">
					<div
						v-if="quarterItem.announcementId"
						class="actions"
						@click="handlePreview(quarterItem.announcementLink)"
					>
						<SvgIcon name="icon_PDF" class="actions-icon" />{{ $t('pages.financials.announcements') }}
					</div>
					<div v-if="quarterItem.roundupLink" class="actions" @click="handlePreview(quarterItem.roundupLink)">
						<SvgIcon name="icon_PDF" class="actions-icon" />
						{{ $t('pages.financials.fullReport') }}
					</div>
					<div v-if="quarterItem.showLink" class="actions" @click="handlePreview(quarterItem.showLink)">
						<SvgIcon name="icon_PPT" class="actions-icon" />
						{{ $t('pages.financials.presentation') }}
					</div>
					<div v-if="quarterItem.roadshowId" class="actions" @click="handlePreview(quarterItem.roadshowLink)">
						<SvgIcon name="icon_video" class="actions-icon" />
						{{ $t('pages.financials.webcast') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FinancialsList',
	props: {
		// 年份
		year: {
			type: [String, Number],
			required: true
		},
		// 该年份的季度数据数组
		items: {
			type: Array,
			required: true,
			default: () => []
		}
	},
	methods: {
		handlePreview(url) {
			if (!url) return;
			// 触发 preview 事件，让父组件处理
			window.open(url, '_blank');
		}
	}
};
</script>

<style scoped lang="less">
@device-width-mobile: 760px;
.financials-content-item {
	display: flex;
	padding-bottom: 32px;
	margin-bottom: 32px;

	&-year {
		flex-shrink: 0;
		width: 216px;
		color: var(--investors-osl-color-black);
		font-size: 20px;
		font-weight: 700;
		line-height: 32px; /* 133.333% */
	}

	.financials-content-item-content {
		width: 100%;
		&-interim {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			.quarter {
				flex-shrink: 0;
				width: 184px;
				color: var(--investors-osl-color-black);
				font-size: 16px;
				font-weight: 700;
				line-height: 32px; /* 133.333% */
			}
			.actions-items {
				width: 100%;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				.actions {
					display: flex;
					align-items: center;
					color: rgba(var(--investors-osl-color-black-rgb), 0.8);
					font-size: 14px;
					font-weight: 400;
					line-height: 18px; /* 128.571% */
					cursor: pointer;
					.actions-icon {
						margin-right: 8px;
						width: 24px;
						height: 24px;
						vertical-align: middle;
					}
				}
			}
			&:not(:last-child) {
				padding-bottom: 38px;
			}
		}
	}
}

@media (max-width: @device-width-mobile) {
	.financials-content-item {
		flex-direction: column;
		padding-bottom: 20px !important;
		margin-bottom: 20px !important;
		&-content {
			&-interim {
				display: flex;
				flex-direction: column;
				padding-bottom: 0 !important;
				.quarter {
					padding: 20px 0 16px;
					width: 100% !important;
					font-size: 16px !important;
				}
				.actions-items {
					gap: 15px;
					grid-template-columns: repeat(2, 2fr) !important;
					justify-items: inherit !important;
					.actions {
						padding: 6px 8px;
						border-radius: 2px;
						border: 0.5px solid var(--border-normal-color);
					}
				}
			}
		}
	}
}
</style>
